import React from 'react';
import './style/footer.css';  

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="links">
        <a href="/">About Us</a>
        <a href="/contact">Contact</a>
        <a href="/resources#helpline">Helpline</a>
        <a href="/">Privacy Policy</a>
      </div>
    </div>
  </footer>
);

export default Footer;
